<template>
    <div class="place-component">
        <h3>{{ eventName }}</h3>
        <p class="date">{{ time }}</p>
        <img
            :src="image"
            v-bind:alt="eventName"
        />
        <div class="address">
            <span class="name">{{ locationName }}</span>
            <span class="line-1">{{ address }}</span>
            <span class="city-state">{{ city }} {{ state }}, {{ zip }}</span>
        </div>
        <a
            v-bind:href="directionsLink"
            target="_blank"
        >
            Get Directions
        </a>
        <p class="instructions">*{{ instructions }}</p>
    </div>
</template>

<script>
export default {
    name: 'place',
    props: [
        'eventName',
        'time',
        'locationName',
        'address',
        'city',
        'state',
        'zip',
        'mapSource',
        'directionsLink',
        'instructions',
        'image'
    ]
};
</script>


// WEBPACK FOOTER //
// src/components/place.vue?8e1c6462